/**
 * dom.js
 * DOM element references
 * Initialized after DOMContentLoaded to ensure all elements exist
 */

// DOM Elements - initialized as null, populated by initElements()
export let elements = {
  app: null,
  sidebar: null,
  sidebarOverlay: null,
  chatList: null,
  messagesContainer: null,
  input: null,
  sendBtn: null,
  newChatBtn: null,
  toggleSidebarBtn: null,
  themeBtn: null,
  settingsBtn: null,
  shortcutsBtn: null,
  settingsModal: null,
  saveSettingsBtn: null,
  closeSettingsBtn: null,
  searchChats: null,
  exportBtn: null,
  importBtn: null,
  importModal: null,
  importFileInput: null,
  confirmImportBtn: null,
  cancelImportBtn: null,
  shortcutsModal: null,
  closeShortcutsBtn: null,
  toastContainer: null,
  attachmentsList: null,
  fileInput: null,
  uploadBtn: null,
  fontTypeSelect: null,
  fontSizeSelect: null,
  themeSelect: null,
  agentSelector: null,
  agentSelectorBtn: null,
  agentDropdown: null,
  agentEmoji: null,
  agentName: null,
};

/**
 * Initialize DOM element references
 * Call this function after DOMContentLoaded
 * Mutates the existing elements object to preserve references
 */
export function initElements() {
  elements.app = document.getElementById("app");
  elements.sidebar = document.getElementById("sidebar");
  elements.sidebarOverlay = document.getElementById("sidebar-overlay");
  elements.chatList = document.getElementById("chat-list");
  elements.messagesContainer = document.getElementById("messages-container");
  elements.input = document.getElementById("message-input");
  elements.sendBtn = document.getElementById("send-btn");
  elements.newChatBtn = document.getElementById("new-chat-btn");
  elements.toggleSidebarBtn = document.getElementById("toggle-sidebar-btn");
  elements.themeBtn = document.getElementById("theme-btn");
  elements.settingsBtn = document.getElementById("settings-btn");
  elements.shortcutsBtn = document.getElementById("shortcuts-btn");
  elements.settingsModal = document.getElementById("settings-modal");
  elements.saveSettingsBtn = document.getElementById("save-settings-btn");
  elements.closeSettingsBtn = document.getElementById("close-settings-btn");
  elements.searchChats = document.getElementById("search-chats");
  elements.exportBtn = document.getElementById("export-btn");
  elements.importBtn = document.getElementById("import-btn");
  elements.importModal = document.getElementById("import-modal");
  elements.importFileInput = document.getElementById("import-file-input");
  elements.confirmImportBtn = document.getElementById("confirm-import-btn");
  elements.cancelImportBtn = document.getElementById("cancel-import-btn");
  elements.shortcutsModal = document.getElementById("shortcuts-modal");
  elements.closeShortcutsBtn = document.getElementById("close-shortcuts-btn");
  elements.toastContainer = document.getElementById("toast-container");
  elements.attachmentsList = document.getElementById("attachments-list");
  elements.fileInput = document.getElementById("file-input");
  elements.uploadBtn = document.getElementById("upload-btn");
  elements.fontTypeSelect = document.getElementById("font-type-select");
  elements.fontSizeSelect = document.getElementById("font-size-select");
  elements.themeSelect = document.getElementById("theme-select");
  elements.agentSelector = document.getElementById("agent-selector");
  elements.agentSelectorBtn = document.getElementById("agent-selector-btn");
  elements.agentDropdown = document.getElementById("agent-dropdown");
  elements.agentEmoji = document.getElementById("agent-emoji");
  elements.agentName = document.getElementById("agent-name");

  return elements;
}
